import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as retrieveNotifications from "./retrieveNotifications";
import * as retrieveUnReadNotificationsNbr from "./retrieveUnReadNotificationsNbr";
import * as markNotificationsAsRead from "./markNotificationsAsRead";

const initialState: State = {
  retrieveNotifications: retrieveNotifications.initialState,
  retrieveUnReadNotificationsNbr: retrieveUnReadNotificationsNbr.initialState,
  markNotificationsAsRead: markNotificationsAsRead.initialState,
};

const reduceState = combineStateReducer(initialState, {
  retrieveNotifications: retrieveNotifications.reduceState,
  retrieveUnReadNotificationsNbr: retrieveUnReadNotificationsNbr.reduceState,
  markNotificationsAsRead: markNotificationsAsRead.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...retrieveNotifications.createSelector(
      () => getState().retrieveNotifications,
    ),
    ...retrieveUnReadNotificationsNbr.createSelector(
      () => getState().retrieveUnReadNotificationsNbr,
    ),
    ...markNotificationsAsRead.createSelector(
      () => getState().markNotificationsAsRead,
    ),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
